import ProductDescription from './ProductDescription'

const WholeMilkProduct = {
  ...ProductDescription,
  category: '51',
  subCategory: '',
  IsBroadband: false,
  WholeMilkType: '',
  WholeMilkSize: '',
}

export default WholeMilkProduct